import RegistrationsService from "@/services/RegistrationsService";
import { formatDate, registrationStatus } from "@/utils/dates";

const getDefaultState = () => {
    return {
        registrations: [],
    };
};

export default {
    state: () => getDefaultState(),
    mutations: {
        setRegistrations: (state, registrations) => {
            state.registrations = registrations;
            for (const elem of state.registrations) {
                elem.status = registrationStatus(elem);
                elem.intDate = new Date(
                    formatDate(elem.arrival_date_from)
                ).getTime();
            }
        },
        setRegistrationsState: state => {
            Object.assign(state, getDefaultState());
        },
    },
    getters: {
        getRegistrations: state => state.registrations,
    },
    actions: {
        processRegistrations: async ({ dispatch, commit }) => {
            try {
                commit("setLoading", true);
                const response = await RegistrationsService.get();
                commit("setRegistrations", response.data.data);
            } catch (e) {
                if (e.response.data.message === "Objects were not found") {
                    commit("setRegistrations", []);
                } else {
                    dispatch("generalErrorHandling", e);
                }
            } finally {
                commit("setLoading", false);
            }
        },

        addRegistration: async ({ dispatch, commit }, registration) => {
            try {
                commit("setLoading", true);
                await RegistrationsService.create(registration);
                await dispatch("processRegistrations");
                commit({
                    type: "alert",
                    text: "New registration saved",
                    color: "primary",
                    icon: "save",
                });
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        editRegistration: async ({ dispatch, commit }, registration) => {
            try {
                commit("setLoading", true);
                await RegistrationsService.update(
                    registration.truck_reg_id,
                    registration
                );
                await dispatch("processRegistrations");
                commit({
                    type: "alert",
                    text: "Registration changes saved",
                    color: "primary",
                    icon: "save",
                });
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        deleteRegistration: async ({ dispatch, commit }, id) => {
            try {
                commit("setLoading", true);
                await RegistrationsService.delete(id);
                await dispatch("processRegistrations");
                commit({
                    type: "alert",
                    text: "Registration deleted",
                    color: "error",
                    icon: "delete_sweep",
                });
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        finish: async ({ dispatch, commit }, id) => {
            try {
                commit("setLoading", true);
                await RegistrationsService.finish(id);
                await dispatch("processRegistrations");
                commit({
                    type: "alert",
                    text: "Finished",
                    color: "success",
                    icon: "check_circle",
                });
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        didNotShow: async ({ dispatch, commit }, id) => {
            try {
                commit("setLoading", true);
                await RegistrationsService.didNotShow(id);
                await dispatch("processRegistrations");
                commit({
                    type: "alert",
                    text: "Did not show",
                    color: "dark",
                    icon: "warning",
                });
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        resetRegistrationsState: ({ commit }) => {
            commit("setRegistrationsState");
        },
    },
};
